

import {
	Chart as ChartJS,
	Legend,
	LineElement,
	RadialLinearScale,
	PointElement,
	Title,
	Tooltip,
	ChartData,
	ChartOptions,
} from 'chart.js';

import { Component, Mixins, Prop } from 'vue-property-decorator';
import { VuetifyMixin, ColorMixin } from '@/mixins';
import { RadarChartSeries } from "@/../types/interfaces/RadarChartSeries";
import { Radar } from 'vue-chartjs/legacy';
import { scoutingScoreColorHex } from '@/mixins/ColorMixin';
import { isNotEmptyArray } from '@/pipes';

ChartJS.register(
	Title,
	Tooltip,
	Legend,
	PointElement,
	RadialLinearScale,
	LineElement
)

@Component({
	components:{
		Radar,
	}
})
export default class RadarChartJS extends Mixins(VuetifyMixin, ColorMixin){
	@Prop({default: 0, type: Number }) private scaleMin: number;
	@Prop({default: 100, type: Number }) private scaleMax: number;
	@Prop({default: 9, type: Number }) private labelSize: number;
	@Prop({required: true}) public labels: string[];
	@Prop({required: true}) public data: RadarChartSeries[];
	@Prop() public longLabels: string[];

	get RadarChartData(): ChartData{
		return {
			// display labels in uppercase
			labels: this.labels.map(l => {return l.toUpperCase()}),

			// chart data
			datasets: this.data.map(d => {
				return {
					label: d.name,
					data: d.values,
					borderColor: scoutingScoreColorHex(85),
					pointBackgroundColor: d.values.map(v => scoutingScoreColorHex(v)),
					pointBorderColor: d.values.map(v => scoutingScoreColorHex(v)),
					pointHoverBackgroundColor: d.values.map(v => scoutingScoreColorHex(v)),
					pointHoverBorderColor: d.values.map(v => scoutingScoreColorHex(v)),
				}
			})
		}
	}

	get RadarChartDataOptions(): ChartOptions {
		const fullLabels = isNotEmptyArray(this.longLabels)? this.longLabels : this.labels;
		return {
			responsive: true,
			maintainAspectRatio: true,
			elements: {
				point: {
					radius: 8,
					hitRadius: 24,
					hoverRadius: 32,
					hoverBorderWidth: 8,
				},
			},
			plugins: {
				legend: {
					display: false
				},
				tooltip: {
					backgroundColor: 'white',
					titleColor: '#1B5E20',
					displayColors: false,
					boxHeight: 20,
					boxWidth: 20,
					titleAlign: 'center',
					titleFont: {
						size: 16,
						weight: 'bold'
					},
					bodyFont: {
						size: 24
					},
					bodyAlign: 'center',
					callbacks: {
						title: function(context) {
							return '';
						},
						label: function(context) {
							const index = context.dataIndex;
							const label = fullLabels[index];
							const value = context.raw;
							return `${label}: ${value}`;							
						},
						labelColor: function(context) {
							return {
								borderColor: scoutingScoreColorHex(90),
								backgroundColor: scoutingScoreColorHex(Number(context.formattedValue)),
							}
						},
						labelTextColor: function(context) {
							return scoutingScoreColorHex(Number(context.formattedValue))
						},
					}
				}
			},
			scales: {
				r: {
					pointLabels: {
						color:(context) => {
							return scoutingScoreColorHex(this.data[0].values[context.index]);
						},
						font: {
							size: this.labelSize,
							weight: 'bold',
						}
					},
					grid: {
						display: true,
						circular: true
					},
					ticks: {
						display: false,
						stepSize: 10
					},
					min: this.scaleMin,
					max: this.scaleMax,
				}
			}
		}
	}
}

